import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '../../../store/authStore'
import { supabase } from '../../../lib/supabase'

export const useGallery = () => {
  const household = useAuthStore((s) => s.household)
  const qc        = useQueryClient()
  const key       = ['gallery', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('gallery_photos')
        .select('id, storage_path, caption, created_at, profiles:uploaded_by(id, display_name, member_color)')
        .eq('household_id', household.id)
        .order('created_at', { ascending: false })
      if (error) throw error
      return data ?? []
    },
  })

  const inv = () => qc.invalidateQueries({ queryKey: key })

  // Add photo by URL (no file upload — storage_path stores the URL directly)
  const addPhoto = useMutation({
    mutationFn: async ({ storage_path, caption }) => {
      const { data: { session } } = await supabase.auth.getSession()
      const { error } = await supabase
        .from('gallery_photos')
        .insert({ household_id: household.id, uploaded_by: session.user.id, storage_path, caption: caption || null })
      if (error) throw error
    },
    onSuccess: inv,
  })

  const deletePhoto = useMutation({
    mutationFn: async (id) => {
      const { error } = await supabase.from('gallery_photos').delete().eq('id', id)
      if (error) throw error
    },
    onSuccess: inv,
  })

  return { ...query, addPhoto, deletePhoto }
}
